<template>
  <div v-if="loaded">
    <auth-modal v-if="!this.error" backlink="login" :btntext="successBtnText">
      <template v-slot:title>
        <h1>{{ $t("auth-verification-complete-modal-title") }}</h1>
      </template>
      <template v-slot:content>
        <p>{{ $t("auth-verification-complete-modal-text") }}</p>
      </template>
    </auth-modal>
    <auth-modal v-else backlink="register" :btntext="errorBtnText">
      <template v-slot:title>
        <h1>{{ $t("auth-verification-failed") }}</h1>
      </template>
      <template v-slot:content>
        <p>{{ $t("auth-verification-failed-description") }}</p>
      </template>
    </auth-modal>
  </div>
</template>

<script>
import Base from "@/views/modules/base/Index";
import AuthModal from "@/components/AuthModal";
import { mapActions } from "vuex";

export default {
  name: "Verification",
  extends: Base,
  components: {
    AuthModal
  },
  data() {
    return {
      error: false,
      loaded: false
    };
  },
  computed: {
    successBtnText() {
      return this.$t("auth-back-to-login");
    },
    errorBtnText() {
      return this.$t("auth-go-to-registration");
    }
  },
  methods: {
    ...mapActions("common", ["showModal"])
  },
  beforeCreate() {
    const token = this.$route.query && this.$route.query.token;

    if (token) {
      const locale = localStorage.getItem("locale");
      const payload = {
        token,
        locale
      };
      this.$store
        .dispatch("auth/verify", payload)
        .then(res => {
          if (res.data && res.status === 200) {
            this.error = false;
          }
        })
        .catch(err => {
          if (err.errorCode === "TOKEN_EXPIRED") {
            this.error = true;
          } else {
            this.showModal({
              title: err.errorCode
            });
          }
        })
        .finally(() => {
          this.loaded = true;
        });
    } else {
      this.$router.push("login");
    }
  }
};
</script>

<style scoped></style>
